<kendo-chart class="kendo-chart-dialog">
  <kendo-chart-axis-defaults
    [majorGridLines]="majorGridLines"
  ></kendo-chart-axis-defaults>
  <kendo-chart-area [height]="chartHeight" [background]="backgroundTheme"></kendo-chart-area>
  <kendo-chart-title>
  </kendo-chart-title>
  <kendo-chart-legend position="bottom" orientation="horizontal" [labels]="valueAxisLabels">
    <kendo-chart-legend-inactive-items [labels]="labelColorInactive"></kendo-chart-legend-inactive-items>
  </kendo-chart-legend>
  <kendo-chart-tooltip [shared]="true">
    <ng-template kendoChartSharedTooltipTemplate let-category="category" let-points="points">
      <div style="font-weight:bold;font-size: 12px;">{{ category }}</div>
      @for (point of points; track point) {
        <div>
          <div [style.color]="point.series.color" style="font-size: 12px;">{{ point.series.name }} : {{ point.value }}</div>
        </div>
      }
    </ng-template>
  </kendo-chart-tooltip>
  <kendo-chart-category-axis>
    <kendo-chart-category-axis-item [categories]="categories" [color]="textColorTheme" [labels]="valueAxisLabels">
    </kendo-chart-category-axis-item>
  </kendo-chart-category-axis>
  <kendo-chart-value-axis>
    <kendo-chart-value-axis-item [color]="textColorTheme" [labels]="valueAxisLabels">
    </kendo-chart-value-axis-item>
  </kendo-chart-value-axis>
  <kendo-chart-series>
    @if (seriesData1Visible) {
      <kendo-chart-series-item [stack]="stacked" [name]="seriesData1Name" [type]="seriesType"
        [color]="'#84bdd9'" [data]="seriesData1">
      </kendo-chart-series-item>
    }
    @if (seriesData2Visible) {
      <kendo-chart-series-item [name]="seriesData2Name" [type]="seriesType" [color]="'#fac3c6'"
        [data]="seriesData2">
      </kendo-chart-series-item>
    }
    @if (seriesData3Visible) {
      <kendo-chart-series-item [name]="seriesData3Name" [type]="seriesType" [color]="'#b6ddbe'"
        [data]="seriesData3">
      </kendo-chart-series-item>
    }
    @if (seriesData4Visible) {
      <kendo-chart-series-item [name]="seriesData4Name" [type]="seriesType" [color]="'#fcd1c0'"
        [data]="seriesData4">
      </kendo-chart-series-item>
    }
    @if (seriesData5Visible) {
      <kendo-chart-series-item [name]="seriesData5Name" [type]="seriesType" [color]="'#fac459'"
        [data]="seriesData5">
      </kendo-chart-series-item>
    }
  </kendo-chart-series>
</kendo-chart>